import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiMutationHook } from '../../../../common/queryClient/createApiMutationHook';
import {
  getMutationFn,
  HttpHeaders,
} from '../../../../common/queryClient/getMutationFn';
import { AlgorithmUrl } from '../../query/AlgorithmUrl';
import { AlgorithmJoinsSchema } from '../schema/AlgorithmJoinsSchema';
import {
  AlgorithmJoinsFormDataType,
  AlgorithmJoinsValidFormDataType,
} from '../schema/types';

const putAlgorithmJoins = (
  id: number,
  algorithmJoins: Partial<AlgorithmJoinsValidFormDataType>,
  headers?: HttpHeaders
) =>
  apiClient
    .put<AlgorithmJoinsFormDataType>(
      expand(AlgorithmUrl.JOINS, { id }),
      AlgorithmJoinsSchema.parseMutationDto(algorithmJoins),
      headers ? { headers } : undefined
    )
    .then((response) => response.data);

export const useMutateAlgorithmJoinsQuery = createApiMutationHook(
  ['algorithmJoins'],
  getMutationFn(undefined, putAlgorithmJoins)
);
